import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class SmartyStreetsService {
	constructor(private httpClient: HttpClient) {}

	addressSuggestionTypeaheadFL = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(500),
			distinctUntilChanged(),
			switchMap(input => {
				const httpParams = new HttpParams().set('address', input);
				return this.httpClient.get(`api/SmartyStreets/LookupFL`, {
					params: httpParams,
				});
			}),
			tap((suggestions: Object[]) => {
				if (suggestions.length === 0) {
					suggestions.push({
						formattedAddress: 'No legitimate postal address found. Click here to freetype a new address.',
					});
					return suggestions;
				} else {
					return suggestions;
				}
			})
		);

	addressSuggestionTypeaheadAllStates = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(500),
			distinctUntilChanged(),
			switchMap(input => {
				const httpParams = new HttpParams().set('address', input);
				return this.httpClient.get(`api/SmartyStreets/LookupAllStates`, {
					params: httpParams,
				});
			}),
			tap((suggestions: Object[]) => {
				if (suggestions.length === 0) {
					suggestions.push({
						formattedAddress: 'No legitimate postal address found. Click here to freetype a new address.',
					});
					return suggestions;
				} else {
					return suggestions;
				}
			})
		);
}
